/**
 * ![brown 50](https://mui.com/static/colors-preview/brown-50-24x24.png) ![brown 100](https://mui.com/static/colors-preview/brown-100-24x24.png) ![brown 200](https://mui.com/static/colors-preview/brown-200-24x24.png) ![brown 300](https://mui.com/static/colors-preview/brown-300-24x24.png) ![brown 400](https://mui.com/static/colors-preview/brown-400-24x24.png) ![brown 500](https://mui.com/static/colors-preview/brown-500-24x24.png) ![brown 600](https://mui.com/static/colors-preview/brown-600-24x24.png) ![brown 700](https://mui.com/static/colors-preview/brown-700-24x24.png) ![brown 800](https://mui.com/static/colors-preview/brown-800-24x24.png) ![brown 900](https://mui.com/static/colors-preview/brown-900-24x24.png) ![brown A100](https://mui.com/static/colors-preview/brown-A100-24x24.png) ![brown A200](https://mui.com/static/colors-preview/brown-A200-24x24.png) ![brown A400](https://mui.com/static/colors-preview/brown-A400-24x24.png) ![brown A700](https://mui.com/static/colors-preview/brown-A700-24x24.png)
 */
const brown = {
  /**
   * Preview: ![brown 50](https://mui.com/static/colors-preview/brown-50-24x24.png)
   */
  50: '#efebe9',
  /**
   * Preview: ![brown 100](https://mui.com/static/colors-preview/brown-100-24x24.png)
   */
  100: '#d7ccc8',
  /**
   * Preview: ![brown 200](https://mui.com/static/colors-preview/brown-200-24x24.png)
   */
  200: '#bcaaa4',
  /**
   * Preview: ![brown 300](https://mui.com/static/colors-preview/brown-300-24x24.png)
   */
  300: '#a1887f',
  /**
   * Preview: ![brown 400](https://mui.com/static/colors-preview/brown-400-24x24.png)
   */
  400: '#8d6e63',
  /**
   * Preview: ![brown 500](https://mui.com/static/colors-preview/brown-500-24x24.png)
   */
  500: '#795548',
  /**
   * Preview: ![brown 600](https://mui.com/static/colors-preview/brown-600-24x24.png)
   */
  600: '#6d4c41',
  /**
   * Preview: ![brown 700](https://mui.com/static/colors-preview/brown-700-24x24.png)
   */
  700: '#5d4037',
  /**
   * Preview: ![brown 800](https://mui.com/static/colors-preview/brown-800-24x24.png)
   */
  800: '#4e342e',
  /**
   * Preview: ![brown 900](https://mui.com/static/colors-preview/brown-900-24x24.png)
   */
  900: '#3e2723',
  /**
   * Preview: ![brown A100](https://mui.com/static/colors-preview/brown-A100-24x24.png)
   */
  A100: '#d7ccc8',
  /**
   * Preview: ![brown A200](https://mui.com/static/colors-preview/brown-A200-24x24.png)
   */
  A200: '#bcaaa4',
  /**
   * Preview: ![brown A400](https://mui.com/static/colors-preview/brown-A400-24x24.png)
   */
  A400: '#8d6e63',
  /**
   * Preview: ![brown A700](https://mui.com/static/colors-preview/brown-A700-24x24.png)
   */
  A700: '#5d4037',
} as const;

export default brown;
